/* Seek Key — first-party tracking pixel.
 *
 * Captura sessão cross-subdomain (.seekkey.com.br) que costura jornada
 * Shopify (seekkey.com.br) → checkout (secure.seekkey.com.br). Envia
 * eventos de funil pro próprio backend (não pro GA4) — popula
 * analytics_events no Supabase pra análise via MCP seekkey-mcp-analytics.
 *
 * Coexiste com GTM/GA4/Stape/Meta CAPI existentes — NÃO os substitui.
 */
(function () {
  'use strict';
  if (!window.fetch || !document.cookie) return;

  var EVENTS_URL = (window.SK_ANALYTICS_ENDPOINT) || 'https://secure.seekkey.com.br/api/analytics/events';
  var COOKIE_DOMAIN = '.seekkey.com.br';
  var COOKIE_DAYS = 30;
  var CLICK_ID_KEYS = ['gclid','fbclid','ttclid','msclkid','wbraid','gbraid','li_fat_id','twclid','epik','irclickid',
    // Q-235 B2: srsltid (organico Merchant Center) + gad_* (anuncio, as vezes sem gclid)
    'srsltid','gad_source','gad_campaignid'];
  var UTM_KNOWN = { utm_source:1, utm_medium:1, utm_campaign:1, utm_term:1, utm_content:1 };

  function getCookie(n) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + n.replace(/([.$?*|{}()[\]\\\/+^])/g, '\\$1') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function setCookie(n, v, days) {
    var exp = new Date(Date.now() + days * 86400000).toUTCString();
    document.cookie = n + '=' + encodeURIComponent(v)
      + '; expires=' + exp
      + '; path=/; domain=' + COOKIE_DOMAIN + '; secure; samesite=lax';
  }

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'sid-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }

  function getOrCreateSessionId() {
    var sid = getCookie('sk_session_id') || uuid();
    setCookie('sk_session_id', sid, COOKIE_DAYS);
    return sid;
  }

  function captureTracking() {
    var out = {};
    try {
      var params = new URLSearchParams(location.search);
      params.forEach(function (val, key) {
        var lk = key.toLowerCase();
        if (lk.indexOf('utm_') === 0 || CLICK_ID_KEYS.indexOf(lk) !== -1) {
          out[lk] = String(val).slice(0, 500);
        }
      });
    } catch (e) {}
    return out;
  }

  function getOrSetFirstTouch(currentTracking) {
    var existing = getCookie('sk_first_touch');
    if (existing) {
      try { return JSON.parse(existing); } catch (e) {}
    }
    if (Object.keys(currentTracking).length === 0) return null;
    var ft = Object.assign({}, currentTracking, { ts: Date.now() });
    try { setCookie('sk_first_touch', JSON.stringify(ft), COOKIE_DAYS); } catch (e) {}
    return ft;
  }

  function getDeviceType() {
    var w = window.innerWidth;
    if (w <= 768) return 'mobile';
    if (w <= 1024) return 'tablet';
    return 'desktop';
  }

  function detectPageType() {
    var p = location.pathname;
    if (/^\/products\//.test(p)) return 'view_product';
    if (/^\/collections\//.test(p)) return 'view_collection';
    if (/^\/search/.test(p)) return 'search';
    if (/^\/cart/.test(p)) return 'view_cart_page';
    if (p === '/' || p === '') return 'view_home';
    return 'page_view';
  }

  function buildEventData() {
    var p = location.pathname;
    var data = { title: document.title || null };
    if (/^\/products\//.test(p)) {
      var pm = p.match(/^\/products\/([^/?]+)/);
      if (pm) data.product_handle = pm[1];
    } else if (/^\/collections\//.test(p)) {
      var cm = p.match(/^\/collections\/([^/?]+)/);
      if (cm) data.collection_handle = cm[1];
    } else if (/^\/search/.test(p)) {
      try { data.query = new URLSearchParams(location.search).get('q') || ''; } catch (e) {}
    }
    return data;
  }

  function send(eventName, eventData) {
    var sid = getOrCreateSessionId();
    var tracking = captureTracking();
    var ft = getOrSetFirstTouch(tracking);

    var meta = {};
    for (var k in tracking) if (!UTM_KNOWN[k]) meta[k] = tracking[k];
    if (ft) {
      for (var fk in ft) meta['ft_' + fk] = String(ft[fk]);
    }

    var body = {
      session_id: sid,
      event_name: eventName,
      event_data: eventData || null,
      page_url: location.pathname + location.search,
      device_type: getDeviceType(),
      utm_source: tracking.utm_source || null,
      utm_medium: tracking.utm_medium || null,
      utm_campaign: tracking.utm_campaign || null,
      utm_term: tracking.utm_term || null,
      utm_content: tracking.utm_content || null,
      tracking_meta: meta,
      referrer: document.referrer || null,
      landing_page: location.pathname + location.search
    };

    try {
      fetch(EVENTS_URL, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        keepalive: true,
        mode: 'cors'
      }).catch(function () {});
    } catch (e) {}
  }

  // Pageview inicial
  try { send(detectPageType(), buildEventData()); } catch (e) {}

  // Intercept Shopify Ajax cart calls pra disparar add_to_cart/remove_from_cart
  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = '';
    try {
      url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    } catch (e) {}
    var promise = origFetch.apply(this, args);
    try {
      if (/\/cart\/add(\.js|\.json)?/.test(url)) {
        promise.then(function () { try { send('add_to_cart', { source: 'fetch' }); } catch (_) {} });
      } else if (/\/cart\/change(\.js|\.json)?/.test(url)) {
        promise.then(function () { try { send('cart_change', { source: 'fetch' }); } catch (_) {} });
      } else if (/\/cart\/update(\.js|\.json)?/.test(url)) {
        promise.then(function () { try { send('cart_update', { source: 'fetch' }); } catch (_) {} });
      } else if (/\/cart\/clear(\.js|\.json)?/.test(url)) {
        promise.then(function () { try { send('cart_clear', { source: 'fetch' }); } catch (_) {} });
      }
    } catch (e) {}
    return promise;
  };
})();
